module.exports = __webpack_public_path__ + "img/Strandtänzerin.304f2b17.jpg";